export const DATE_FILTERS = ['all', 'today', 'week', 'month', 'year']
export const TRI_FILTERS = ['all', 'with', 'without']
export const LEGACY_FILTER_KEYS = [
  'selectedCertaintyLevels',
  'cartCertaintySort',
  'certaintyFilters',
  'certaintyLevels',
  'filterCertainty',
]

export function emptyCartFilters() {
  return {
    priceMin: '',
    priceMax: '',
    hasImage: 'all',
    hasLink: 'all',
    dateFilter: 'all',
  }
}

export function normalizeTriFilter(value) {
  if (value === true || value === 'with' || value === 'true') return 'with'
  if (value === false || value === 'without' || value === 'false') return 'without'
  return 'all'
}

export function sanitizeCartFilters(raw = {}) {
  const next = emptyCartFilters()
  if (raw && typeof raw === 'object') {
    next.priceMin = raw.priceMin == null ? '' : String(raw.priceMin)
    next.priceMax = raw.priceMax == null ? '' : String(raw.priceMax)
    next.hasImage = normalizeTriFilter(raw.hasImage)
    next.hasLink = normalizeTriFilter(raw.hasLink)
    next.dateFilter = DATE_FILTERS.includes(raw.dateFilter) ? raw.dateFilter : 'all'
  }
  return next
}

export function parsePriceBound(value) {
  if (value === '' || value == null) return null
  const parsed = Number.parseFloat(value)
  return Number.isFinite(parsed) ? parsed : null
}

export function validatePriceRange(priceMin, priceMax) {
  const min = parsePriceBound(priceMin)
  const max = parsePriceBound(priceMax)
  if (min != null && min < 0) return 'Le prix minimum ne peut pas être négatif.'
  if (max != null && max < 0) return 'Le prix maximum ne peut pas être négatif.'
  if (min != null && max != null && min > max) {
    return 'Le prix minimum doit être inférieur ou égal au maximum.'
  }
  return null
}

export function countActiveFilters(filters) {
  const value = sanitizeCartFilters(filters)
  let count = 0
  if (parsePriceBound(value.priceMin) != null) count += 1
  if (parsePriceBound(value.priceMax) != null) count += 1
  if (value.hasImage !== 'all') count += 1
  if (value.hasLink !== 'all') count += 1
  if (value.dateFilter !== 'all') count += 1
  return count
}

function matchesDateFilter(createdAt, dateFilter, now = new Date()) {
  if (!dateFilter || dateFilter === 'all' || !createdAt) return true
  const itemDate = new Date(createdAt)
  if (Number.isNaN(itemDate.getTime())) return true
  const diffDays = (now.getTime() - itemDate.getTime()) / (1000 * 60 * 60 * 24)
  if (dateFilter === 'today') return diffDays < 1
  if (dateFilter === 'week') return diffDays < 7
  if (dateFilter === 'month') return diffDays < 30
  if (dateFilter === 'year') return diffDays < 365
  return true
}

function hasProductImage(item) {
  return !!(item?.image_url || item?.image_key)
}

function hasProductLink(item) {
  return !!(item?.link && String(item.link).trim())
}

export function applyCartFilters(items, {
  searchTerm = '',
  filters = emptyCartFilters(),
  priceSort = null,
} = {}, now = new Date()) {
  const source = Array.isArray(items) ? items : []
  const value = sanitizeCartFilters(filters)
  const rangeError = validatePriceRange(value.priceMin, value.priceMax)
  const min = parsePriceBound(value.priceMin)
  const max = parsePriceBound(value.priceMax)
  const needle = String(searchTerm || '').trim().toLowerCase()

  let filtered = source.filter((item) => {
    if (needle) {
      const name = String(item?.name || '').toLowerCase()
      const link = String(item?.link || '').toLowerCase()
      if (!name.includes(needle) && !link.includes(needle)) return false
    }

    const price = Number.parseFloat(item?.price || 0) || 0
    if (!rangeError) {
      if (min != null && price < min) return false
      if (max != null && price > max) return false
    }

    if (value.hasImage === 'with' && !hasProductImage(item)) return false
    if (value.hasImage === 'without' && hasProductImage(item)) return false
    if (value.hasLink === 'with' && !hasProductLink(item)) return false
    if (value.hasLink === 'without' && hasProductLink(item)) return false
    if (!matchesDateFilter(item?.created_at, value.dateFilter, now)) return false
    return true
  })

  if (priceSort === 'asc') {
    filtered = [...filtered].sort((a, b) => (Number.parseFloat(a.price) || 0) - (Number.parseFloat(b.price) || 0))
  } else if (priceSort === 'desc') {
    filtered = [...filtered].sort((a, b) => (Number.parseFloat(b.price) || 0) - (Number.parseFloat(a.price) || 0))
  }

  return filtered
}

export function forgetLegacyFilterPrefs(storage = typeof localStorage === 'undefined' ? null : localStorage) {
  if (!storage) return
  LEGACY_FILTER_KEYS.forEach((key) => {
    try {
      storage.removeItem(key)
    } catch (_) {
      /* quota / mode privé */
    }
  })
  try {
    const raw = storage.getItem('cartFilters')
    if (!raw) return
    const parsed = JSON.parse(raw)
    if (!parsed || typeof parsed !== 'object') return
    const next = sanitizeCartFilters(parsed)
    storage.setItem('cartFilters', JSON.stringify(next))
  } catch (_) {
    try {
      storage.removeItem('cartFilters')
    } catch (__) {
      /* ignore */
    }
  }
}
